/* Same-photo carry-over for the post-purchase "One photo. Many keepsakes." offer.
   The email links to /pages/same-photo-30?order=%23D1234&photos=<enc>,<enc>,... —
   the landing section calls DollfySamePhoto.capture() to store those photo URLs in
   localStorage (90 days) and ping /discount/<code> so checkout auto-applies the code.
   personalizer.js calls DollfySamePhoto.read() when a fresh session has no photos yet,
   so the customer's previous photos appear pre-loaded in the photos step. */
(function () {
  'use strict';

  var KEY = 'dollfy:same-photo';
  var MAX_AGE_MS = 90 * 24 * 3600 * 1000; // mirrors the 90-day usefulness of a past order
  var MAX_PHOTOS = 12;
  // Same rule as personalizer-upload.js isValidUploadedUrl — https + image pathname.
  var URL_RE = /\.(jpe?g|png|webp)$/i;

  function validUrl(u) {
    try {
      var p = new URL(u);
      return p.protocol === 'https:' && URL_RE.test(p.pathname);
    } catch (err) { return false; }
  }

  // Raw (still %-encoded) query value: split on ',' BEFORE decoding, because
  // urlencoded photo URLs may contain %2C which must stay inside one piece.
  function rawParam(name) {
    var m = window.location.search.match(new RegExp('[?&]' + name + '=([^&]*)'));
    return m ? m[1] : null;
  }

  function read() {
    try {
      var p = JSON.parse(window.localStorage.getItem(KEY) || 'null');
      if (!p || !p.ts || Date.now() - p.ts > MAX_AGE_MS) return null;
      p.photos = (p.photos || []).filter(function (x) { return x && validUrl(x.url); }).slice(0, MAX_PHOTOS);
      return p.photos.length ? p : null;
    } catch (err) { return null; }
  }

  /* Landing entry point: capture ?photos=&order= into storage; returns the
     stored payload (fresh or previous) so the page can show a status chip. */
  function capture() {
    var raw = rawParam('photos');
    if (raw) {
      var photos = raw.split(',')
        .map(function (x) { try { return decodeURIComponent(x); } catch (err) { return ''; } })
        .filter(validUrl)
        .slice(0, MAX_PHOTOS)
        .map(function (u) { return { url: u, name: 'From your last order' }; });
      var order = '';
      var om = rawParam('order');
      if (om) { try { order = decodeURIComponent(om).slice(0, 20); } catch (err) { /* keep '' */ } }
      if (photos.length) {
        try { window.localStorage.setItem(KEY, JSON.stringify({ photos: photos, order: order, ts: Date.now() })); } catch (err) { /* storage blocked — chip just won't show */ }
      }
    }
    return read();
  }

  /* Shopify sets the discount cookie on the /discount/<code> request itself,
     so a background fetch applies the code without navigating away. */
  function applyDiscount(code) {
    if (!code) return;
    try { window.fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' }).catch(function () { /* offline — the code still works typed manually */ }); } catch (err) { /* old browser */ }
  }

  window.DollfySamePhoto = { capture: capture, read: read, applyDiscount: applyDiscount };
})();
